// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OBsw","option":"styles_option__2TCrs","active":"styles_active__8t8Ny"};